import React from 'react';
import { Alert, AlertTitle, AlertDescription } from '../ui/alert';
import { Button } from '../ui/button';

export interface SystemStatusBannerProps {
  /** Whether the system is in bootstrap mode (no IdP configured) */
  readonly bootstrapMode: boolean;
  /** Callback when the user clicks the configure IdP action */
  readonly onConfigureIdp?: () => void;
}

/**
 * Displays a warning alert when the system is in bootstrap mode,
 * prompting the administrator to configure an Identity Provider.
 */
export function SystemStatusBanner({ bootstrapMode, onConfigureIdp }: SystemStatusBannerProps): React.ReactElement | null {
  if (!bootstrapMode) {
    return null;
  }

  return (
    <Alert variant="warning">
      <AlertTitle>System Setup Required</AlertTitle>
      <AlertDescription>
        An Identity Provider must be configured before the system can serve regular users.
        Please complete the IdP setup to enable authentication.
      </AlertDescription>
      {onConfigureIdp && (
        <Button
          type="button"
          className="mt-2"
          onClick={onConfigureIdp}
        >
          Configure Identity Provider
        </Button>
      )}
    </Alert>
  );
}
